import React from 'react';
import './genderblogs.css';
import axios from 'axios';
import renderHTML from 'react-render-html';

class whatisgender extends React.Component{

    
    constructor() {
        super();
        this.state = {
          post: [],
        };
      }
    

    componentDidMount() {
        axios.get('http://localhost/finalyearproject/wp-json/wp/v2/gender?slug=what-is-gender')
    .then(response => {
      this.setState({ post: response.data });
    })
    .catch(error => {
        console.log(error);
    });
        }
    
        render() {
            return (
        
              <div>
                {this.state.post.map(single => {
                    return(
                    <div className="blogcontainer">
                      
                      <div>
                      <img src = {single.acf.image}  alt = "Gender symbols" className = "blogimage"/>
                      </div>

                      <div className="blogtitle">
                      <h1>{single.title.rendered}</h1>
                      </div>
                      <div className = "blogtext">
                    {renderHTML(single.acf.post)}
                      </div>
                      <div className="author">
                        <p>  Blog written by {single.acf.author}</p>
                    </div>
                      <div className = "source">
                          <p> <a href = {single.acf.source}>Read more </a>   </p>
                      </div>
                      
                    </div>                                        
                    );
                })}
              </div>
            );
          }
        }
       

export default whatisgender;